import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScullyLibModule } from '@scullyio/ng-lib';

import { CarouselModule } from 'ngx-owl-carousel-o';

import { HomeComponent } from './home/home.component';
import { CookieComponent } from './cookie/cookie.component';
import { FooterComponent } from './page-parts/footer/footer.component';
import { NavComponent } from './page-parts/nav/nav.component';
import { DietaChetogenicaComponent } from './dieta-chetogenica/dieta-chetogenica.component';
import { ProtocolloChetogenicoComponent } from './protocollo-chetogenico/protocollo-chetogenico.component';
import { ChiSonoComponent } from './chi-sono/chi-sono.component';
import { PartnerComponent } from './partner/partner.component';

@NgModule({
  declarations: [
    AppComponent,

    HomeComponent,
    CookieComponent,
    FooterComponent,
    NavComponent,
    DietaChetogenicaComponent,
    ProtocolloChetogenicoComponent,
    ChiSonoComponent,
    PartnerComponent
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    ScullyLibModule,
    CarouselModule
  ],

  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
